import { ClipboardCheck, FileClock } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { PendingReviewItem } from './pendingReview'

export function PendingReviewPanel({ items }: { items: PendingReviewItem[] }) {
  const totalStages = items.reduce((sum, item) => sum + item.pendingStages.length, 0)

  return (
    <section
      aria-labelledby="awaiting-review-title"
      className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-5"
    >
      <div className="flex items-center justify-between gap-3">
        <h2
          id="awaiting-review-title"
          className="flex items-center gap-2 text-sm font-semibold text-amber-900"
        >
          <FileClock className="h-4 w-4" aria-hidden="true" />
          Documents awaiting review
        </h2>
        {items.length > 0 && (
          <span className="rounded-full bg-amber-700 px-2.5 py-0.5 text-xs font-bold text-white">
            {items.length}
          </span>
        )}
      </div>

      {items.length === 0 ? (
        <p className="mt-3 flex items-center gap-2 text-sm text-amber-800">
          <ClipboardCheck className="h-4 w-4" aria-hidden="true" />
          All caught up — no documents waiting to be verified.
        </p>
      ) : (
        <>
          <p className="mt-1 text-xs text-amber-800">
            {totalStages} stage{totalStages === 1 ? '' : 's'} with new uploads across {items.length}{' '}
            project{items.length === 1 ? '' : 's'}. Open a project to review and mark stages
            complete.
          </p>
          <ul className="mt-3 space-y-2">
            {items.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/admin/projects/${item.id}`}
                  className="flex items-center justify-between gap-3 rounded-lg border border-amber-200 bg-white px-3 py-2 text-sm transition hover:border-amber-300 hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500/50"
                >
                  <span className="min-w-0 truncate font-medium text-slate-800">{item.name}</span>
                  <span className="shrink-0 text-xs text-amber-700">
                    {item.pendingStages.length} stage{item.pendingStages.length === 1 ? '' : 's'} ·
                    #{item.pendingStages.join(', #')}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  )
}
